export const getLogoHref = (
  isDefaultLogo: boolean,
  isPaidPlan?: boolean,
  logoHref?: string
): string | undefined => {
  if (isDefaultLogo && !isPaidPlan && !logoHref) {
    return "https://smartsuite.com";
  }

  if (logoHref) {
    return logoHref;
  }

  return undefined;
};

export const shouldHideFormLogo = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("header") === "false";
};
